export function typedObjectKeys<T extends object>(record: T): Array<keyof T> {
  return Object.keys(record) as Array<keyof T>;
}
